import React from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { ResizableBox } from 'react-resizable-ext';
import merge from 'lodash/merge';

import HeaderCell from './HeaderCell';
import { rowHasColumnPath } from 'components/FieldColumns/columnHeader';

export const SortableList = SortableContainer(
  ({
    columns,
    style,
    sortIcon,
    filters,
    sortColumnIndex,
    headerRightOffset,
    fixedCellWidth,
    handleResizeStart,
    handleResizeColumn,
    handleOpenFilterDialog,
    handleSortData,
    withOrdering,
    withFiltration,
    withSorting,
    activeFilterColumnIndex,
  }) => {
    // Decide once per row, not per column: if no column has a resolved path,
    // no column reserves space for one. Keeps views whose paths have not been
    // backfilled looking exactly as they did before this feature.
    const showHierarchy = rowHasColumnPath(columns);

    return (
      <div
        style={merge({}, style, {
          right: headerRightOffset,
          left: 'none',
        })}
        className="header-row"
        role="row"
      >
        <div className="header-cell-fixed" style={{ width: fixedCellWidth - 1 }} />

        {columns.map((value, colIndex) => {
          return (
            <SortableItem
              key={`item-${colIndex}`}
              index={colIndex}
              colIndex={colIndex}
              value={value}
              width={value.width}
              filters={filters}
              sortColumnIndex={sortColumnIndex}
              sortIcon={sortIcon}
              handleResizeStart={handleResizeStart}
              handleResizeColumn={handleResizeColumn}
              handleOpenFilterDialog={handleOpenFilterDialog}
              handleSortData={handleSortData}
              withFiltration={value.type === "photo" ? false : withFiltration}
              withOrdering={withOrdering}
              withSorting={withSorting}
              isFilterActive={activeFilterColumnIndex === value.index}
              showHierarchy={showHierarchy}
            />
          );
        })}
      </div>
    );
  },
);

const SortableItem = SortableElement(
  ({
    value,
    colIndex,
    width,
    sortColumnIndex,
    filters,
    sortIcon,
    handleResizeStart,
    handleResizeColumn,
    handleOpenFilterDialog,
    handleSortData,
    withFiltration,
    withOrdering,
    withSorting,
    isFilterActive,
    showHierarchy,
  }) => {
    return (
      <ResizableBox
        width={width}
        axis={withOrdering ? 'x' : 'none'}
        height={36}
        onResizeStart={withOrdering ? handleResizeStart : null}
        onResizeStop={withOrdering ? handleResizeColumn : null}
        id={value.index}
      >
        <HeaderCell
          height={36}
          column={value}
          width={width}
          filters={filters}
          sortColumnIndex={sortColumnIndex}
          onSortData={handleSortData}
          onFilterDialogOpen={handleOpenFilterDialog}
          sortIcon={sortIcon}
          colIndex={colIndex}
          withFiltration={withFiltration}
          withOrdering={withOrdering}
          withSorting={withSorting}
          isFilterActive={isFilterActive}
          showHierarchy={showHierarchy}
        />
      </ResizableBox>
    );
  },
);
